import { render } from "./Heavy.svg?vue&type=template&id=191f698a"
const script = {}
script.render = render

export default script